import { BusinessServices } from './enums/business-services';

export const MdlaDomain: Readonly<string> = 'SHSDigiCare';

export enum ServiceName {
    RequestService = 'SHSDigiCare.RequestService',
    ClwService = 'SHSDigiCare.ContractLifecycleService',
    OmEmeaRequestService = 'SHSDigiCare.OmEmeaRequestService',
    IroNamService = 'SHSDigiCare.IroNamService',
    UserService = 'SHSDigiCare.UserService',
    CommentService = 'SHSDigiCare.CommentService'
}

/**
 * The business service a source service belongs to. Resources partitioned by
 * `ServiceName` - rule engine rules and translation files - are region data, so
 * anything authorising access to them has to resolve the owning stream first.
 *
 * Services shared across all regions, like the user and comment service, map to
 * no single stream and are absent here on purpose.
 */
export const SERVICE_NAME_STREAM: Readonly<Partial<Record<ServiceName, BusinessServices>>> = {
    [ServiceName.OmEmeaRequestService]: BusinessServices.OM_EMEA,
    [ServiceName.RequestService]: BusinessServices.OM_NAM,
    [ServiceName.IroNamService]: BusinessServices.OM_NAM,
    [ServiceName.ClwService]: BusinessServices.CLW
};

/**
 * The business service owning the given source service, or `undefined` for
 * services that are not scoped to one.
 */
export const getStreamByServiceName = (serviceName: ServiceName): BusinessServices | undefined =>
    SERVICE_NAME_STREAM[serviceName];
